var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner-section-4 bg_img oh"},[_c('div',{staticClass:"banner-shape d-none d-lg-block bot-0"}),_c('div',{staticClass:"container-fluid p-0"},[_c('bannerSlide')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }